/* ================================================================ */
/* EcomRise Bundle - Merge Script                                    */
/* Moves checkbox + name + variant + price into each product image  */
/* ================================================================ */

(function() {
  'use strict';

  function mergeBundleCards() {
    const wrappers = document.querySelectorAll('.er-bundle__wrapper');
    if (!wrappers.length) return false;

    let anyMerged = false;
    wrappers.forEach(function(wrapper) {
      if (wrapper.dataset.merged === '1') return;

      const images = wrapper.querySelectorAll('.er-bundle__image');
      const items  = wrapper.querySelectorAll('.er-bundle-item');
      if (!images.length || !items.length) return;
      if (images.length !== items.length) return; // safety

      images.forEach(function(imageBox, idx) {
        const item = items[idx];
        if (!item) return;

        // 1) Get the original checkbox input
        const originalCheckbox = item.querySelector('input[type="checkbox"][data-er-role="item-checkbox"]');
        const originalLabel    = item.querySelector('.er-item__checkbox-display');

        // 2) Build the visible overlay checkbox on top of the image
        const overlay = document.createElement('div');
        overlay.className = 'er-merged-checkbox' + (originalCheckbox && originalCheckbox.checked ? '' : ' is-unchecked');
        overlay.setAttribute('role', 'checkbox');
        overlay.setAttribute('aria-checked', originalCheckbox && originalCheckbox.checked ? 'true' : 'false');
        overlay.setAttribute('tabindex', '0');

        // Click on overlay -> toggle real checkbox (so EcomRise updates totals)
        overlay.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (!originalCheckbox) return;
          // Toggle via the visible label so EcomRise's bound event fires
          if (originalLabel) {
            originalLabel.click();
          } else {
            originalCheckbox.click();
          }
        });

        overlay.addEventListener('keydown', function(e) {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            overlay.click();
          }
        });

        // Place overlay inside the image box (it is position:relative via CSS)
        const imgLink = imageBox.querySelector('a') || imageBox;
        imgLink.style.position = 'relative';
        imgLink.appendChild(overlay);

        // 3) Build merged info block (name + variant + price)
        const info = document.createElement('div');
        info.className = 'er-merged-info';

        // Name
        const titleEl = item.querySelector('.er-item__title');
        if (titleEl) {
          const name = document.createElement('p');
          name.className = 'er-merged-name';
          // Get text only, no nested links
          const text = titleEl.textContent.trim().replace(/\s+/g, ' ');
          // Remove the "x1" multiplier suffix from displayed name (keep it minimal)
          name.textContent = text.replace(/\s*This item:\s*/i, '').replace(/\s*x\d+\s*$/i, '');
          info.appendChild(name);
        }

        // Variant select - clone and bind
        const originalSelect = item.querySelector('select[data-er-role="item-variant"]');
        if (originalSelect && originalSelect.options.length > 1) {
          const clonedSelect = originalSelect.cloneNode(true);
          clonedSelect.removeAttribute('data-er-role');
          clonedSelect.classList.add('er-merged-variant-select');
          // When clone changes, update original (so EcomRise re-prices)
          clonedSelect.addEventListener('change', function() {
            originalSelect.value = clonedSelect.value;
            originalSelect.dispatchEvent(new Event('change', { bubbles: true }));
          });
          info.appendChild(clonedSelect);
        }

        // Price block
        const priceWrap = document.createElement('p');
        priceWrap.className = 'er-merged-price';
        const comparedEl = item.querySelector('[data-er-role="item-price-compared"]');
        const regularEl  = item.querySelector('[data-er-role="item-price"]');
        if (comparedEl && comparedEl.textContent.trim()) {
          const cmp = document.createElement('span');
          cmp.className = 'er-merged-compare';
          cmp.setAttribute('data-er-mirror', 'compared');
          cmp.textContent = comparedEl.textContent.trim();
          priceWrap.appendChild(cmp);
        }
        if (regularEl) {
          const reg = document.createElement('span');
          reg.setAttribute('data-er-mirror', 'regular');
          reg.textContent = regularEl.textContent.trim();
          priceWrap.appendChild(reg);
        }
        info.appendChild(priceWrap);

        // Append info to image box (after the link)
        imageBox.appendChild(info);

        // 4) Sync card highlight + overlay state when original changes
        const updateState = function() {
          if (!originalCheckbox) return;
          if (originalCheckbox.checked) {
            imageBox.classList.add('is-merged-selected');
            overlay.classList.remove('is-unchecked');
            overlay.setAttribute('aria-checked', 'true');
          } else {
            imageBox.classList.remove('is-merged-selected');
            overlay.classList.add('is-unchecked');
            overlay.setAttribute('aria-checked', 'false');
          }
        };
        updateState();

        if (originalCheckbox) {
          originalCheckbox.addEventListener('change', updateState);
        }

        // 5) Mirror price changes from original to merged when variant changes / totals re-render
        const observer = new MutationObserver(function() {
          // Re-read prices and update mirrors
          const cmpEl = item.querySelector('[data-er-role="item-price-compared"]');
          const regEl = item.querySelector('[data-er-role="item-price"]');
          const mirrorCmp = info.querySelector('[data-er-mirror="compared"]');
          const mirrorReg = info.querySelector('[data-er-mirror="regular"]');
          if (cmpEl && mirrorCmp) mirrorCmp.textContent = cmpEl.textContent.trim();
          if (regEl && mirrorReg) mirrorReg.textContent = regEl.textContent.trim();
          updateState();
        });
        observer.observe(item, { childList: true, subtree: true, characterData: true });
      });

      wrapper.dataset.merged = '1';
      anyMerged = true;
    });

    return anyMerged;
  }

  // Try multiple times since EcomRise renders async
  function tryMerge() {
    if (mergeBundleCards()) return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryMerge);
  } else {
    tryMerge();
  }

  // Retry on a few intervals to catch async-loaded bundles
  const retryTimes = [500, 1200, 2500, 5000];
  retryTimes.forEach(function(ms) {
    setTimeout(tryMerge, ms);
  });

  // Watch the body for late-injected bundles
  if (window.MutationObserver) {
    const bodyObserver = new MutationObserver(function() {
      if (document.querySelector('.er-bundle__wrapper:not([data-merged="1"])')) {
        tryMerge();
      }
    });
    if (document.body) {
      bodyObserver.observe(document.body, { childList: true, subtree: true });
      // Stop watching after 15s to avoid perf cost
      setTimeout(function() { bodyObserver.disconnect(); }, 15000);
    }
  }
})();
